import styled from "styled-components";

const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ gap = "1.5rem" }) => gap};
`;

export default Rows;
